// extracted by mini-css-extract-plugin
export default {"backButton":"Affh3oHztJwus38AB6Re","icon":"uvJJDkdTsw17OZyKaPip"};